module.exports = __webpack_public_path__ + "static/media/promocoes-proximas.167146c4.jpg";